// extracted by mini-css-extract-plugin
export default {"form":"CAqVPzON","preloaderWrapper":"V8fFzddo"};